import { render, staticRenderFns } from "./LotteryBalls.vue?vue&type=template&id=0abaa7f6&"
import script from "./LotteryBalls.vue?vue&type=script&lang=js&"
export * from "./LotteryBalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports